import React from 'react';
import appApi from '../../../api/app-api';
import { toast } from 'react-toastify';
import { CreateDonationDto } from '../../../api/types/donations/donor-institution';

export const createDonationOperation = async (
  donorId: number,
  donationData: CreateDonationDto,
  setIsSaveLoading: React.Dispatch<React.SetStateAction<boolean>>,
  closeDialog: () => void,
  onSuccess?: () => void,
) => {
  try {
    if (donationData.amount <= 0) {
      toast.warn('יש להזין סכום חיובי');
      return;
    }

    if (!donationData.paymentDate) {
      toast.warn('יש להזין תאריך תשלום');
      return;
    }

    setIsSaveLoading(true);
    await appApi.createDonation(donorId, donationData);
    toast.success('התרומה נוספה בהצלחה');
    closeDialog();
    if (onSuccess) {
      onSuccess();
    }
  } catch (error) {
    console.error('Error creating donation:', error);
    toast.error('שגיאה בהוספת התרומה');
  } finally {
    setIsSaveLoading(false);
  }
};
